import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_apprenticeship_trainee_internship_progra'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_apprenticeship_trainee_internship_progra',
  name: 'Which of the following apprenticeship / trainee / internship programs does the facility offer/ participate in?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'APPRENTICESHIP_PROGRAM',
      text: 'Apprenticeship program',
      externalIds: [
        {
          id: 'cl-5-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe your apprenticeship program:',
        externalIds: [
          {
            id: 'cl-5-1f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'TRAINEE_PROGRAM',
      text: 'Trainee program',
      externalIds: [
        {
          id: 'cl-5-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe your trainee program:',
        externalIds: [
          {
            id: 'cl-5-2f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'INTERNSHIP_PROGRAM',
      text: 'Internship program',
      externalIds: [
        {
          id: 'cl-5-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe your internship program:',
        externalIds: [
          {
            id: 'cl-5-3f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: ['APPRENTICESHIP_PROGRAM', 'TRAINEE_PROGRAM', 'INTERNSHIP_PROGRAM'],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'rh-app-2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 4750,
  sectionId: '2.2.4.1',
  impactArea: 'Recruitment, Hiring & Termination Practices',
  impactAreaId: 'RECRUITMENT_HIRING_AND_TERMINATION_PRACTICES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
